// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2UMAF","additionalInfo":"AgreementModal_additionalInfo__3gEAX"};